import React, { useState } from "react";
import { GoQuestion } from "react-icons/go";

const RiskLevel2_Table = ({ clCalculation, RiskLevel2_Data,RiskLevel1_Data }) => {
  const [showAll, setShowAll] = useState(false);

  const displayedData = showAll
    ? RiskLevel2_Data
    : RiskLevel2_Data?.slice(0, 4);

  const handleToggle = () => {
    setShowAll(!showAll);
  };
  const formatNumber = (number) => {
    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(Math.abs(number));
  };
  return (
    <div className="acu_tablelistbox">
      <div className="acuntheading">
        Neutral Stop Loss -{" "}
        {clCalculation ? `$${formatNumber(clCalculation?.neutralDRPT)}` : "Na"}
      </div>
      <div className="acunttablemainbox table-responsive">
        <table className="table table-borderless mb-0">
          <thead>
            <tr>
              <th scope="col" className="first_th">
                <span className="icontext">
                  <h4 class="tooltip-target amount-data">Total Contracts</h4>
                  <div className="tooltipico">
                    <div class="tooltip-container">
                      <span className="tooltipsvg">
                        <GoQuestion />
                      </span>
                      <div class="tooltip">
                        Total Contracts is the max amount of contracts you can
                        trade based on the size of your stop loss.
                        </div>
                    </div>
                  </div>
                </span>
              </th>
              <th scope="col" className="amount-data">
              <span className="icontext mlauto">
                      <h4 class="tooltip-target amount-data">Size of Stop Loss in Points</h4>
                      <div className="tooltipico">
                        <div class="tooltip-container">
                          <span className="tooltipsvg">
                            <GoQuestion />
                          </span>
                          <div class="tooltip">
                          The distance from your entry to your stop loss, measured in
                    points or 1.00 increments.
                          </div>
                        </div>
                      </div>
                    </span>
              </th>

              <th scope="col" className="amount-data">
              <span className="icontext mlauto">
                      <h4 class="tooltip-target amount-data">Size of Stop Loss in Ticks</h4>
                      <div className="tooltipico">
                        <div class="tooltip-container">
                          <span className="tooltipsvg">
                            <GoQuestion />
                          </span>
                          <div class="tooltip">
                          The distance from your entry to your stop loss, measured in
                    ticks.
                          </div>
                        </div>
                      </div>
                    </span>
              </th>
              {/* <th scope="col">TP 1 Contracts</th>
            <th scope="col">TP 1 Ticks</th>
            <th scope="col">TP 1 Profit $</th>
            <th scope="col">TP 2 Profit $</th>
            <th scope="col">TP 3 Profit $</th>
            <th scope="col">TP 4 Profit $</th> */}
            </tr>
          </thead>
          <tbody>
            {RiskLevel2_Data?.map((data, index) => (
              <tr key={RiskLevel1_Data?.length+ index + 1}>
             {RiskLevel1_Data?   <td>{RiskLevel1_Data?.length+ index + 1}</td>:<td>{ index + 1}</td>}
                <td className="amount-data">{formatNumber(data.sL_Points)}</td>
                <td className="amount-data">{formatNumber(data.sL_Ticks)}</td>
                {/* <td className='amount-data'>{formatNumber(data.tP_1_Contracts)}</td>
            <td className='amount-data'>{formatNumber(data.tP_1_TicksT)}</td>
            <td className='amount-data'>{data.tP_1_Profit==="null"?"---":`$${formatNumber(data.tP_1_Profit)}`}</td>
            <td className='amount-data'>{data.tP_2_Profit==="null"?"---":`$${formatNumber(data.tP_2_Profit)}`}</td>
            <td className='amount-data'>{data.tP_3_Profit==="null"?"---":`$${formatNumber(data.tP_3_Profit)}`}</td>
            <td className='amount-data'>{data.tP_4_Profit==="null"?"---":`$${formatNumber(data.tP_4_Profit)}`}</td> */}
              </tr>
            ))}
          </tbody>
        </table>
        {/* <div className='showmorbtnbox'>
      {RiskLevel2_Data?.length > 4 ? (  <button class="highlightbutton" disabled="" onClick={handleToggle}> {showAll ? 'Show Less' : 'Show More'}</button>):""}
      </div> */}
      </div>
    </div>
  );
};

export default RiskLevel2_Table;
